<template>
  <div class="form-group has-float-label">
    <vue-tel-input
      @input="e => $emit('input', e)"
      :value="defaultInput"
      :id="Math.random()"
      @validate="isValidate"
    ></vue-tel-input>
  </div>
</template>
<script>
/* https://github.com/EducationLink/vue-tel-input more ref here*/
import "vue-tel-input/dist/vue-tel-input.css";
import VueTelInput from "vue-tel-input";

export default {
  name: "input",
  components: {
    VueTelInput
  },
  props: ["defaultInput"],
  methods: {
    isValidate(result) {
      this.$emit("validate", result);
    }
  }
};
</script>
<style>
.vue-tel-input[data-v-29985a25] {
  border: 2px solid #007bff;
  height: 43px;
  border-radius: 0px;
  border-left-width: 4px;
}
</style>
<style>
ul {
  z-index: 5 !important;
}
</style>
